export default "__VITE_ASSET__Cqw1yWD4__"